import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    logo: {
      padding: 0,
    },
    logoImg: {
      [theme.breakpoints.down('sm')]: {
        height: '40px',
      },
    },
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 7),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '200px',
      },
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    mainMenu: {
      listStyle: 'none',
      margin: 0,
      padding: '15px 2.5px',
      textAlign: 'right',
    },
    mainMenuItem: {
      padding: '14px 25px',
      fontSize: '16px',
      lineHeight: '16px',
      display: 'inline-block',
      color: theme.colors.common1,
    },
    mainMenuItemLink: {
      color: theme.colorTokens.onSurfaceTextHeadline,
      fontWeight: 500,
      transition: 'all 0.3s ease 0s',
      textDecoration: 'none',
      '&:hover': {
        color: theme.colorTokens.hyperlink,
      },
      '&.active': {
        color: theme.colorTokens.hyperlink,
      },
    },
  };
};
